import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AuthService } from 'services/auth'
import { SegmentService } from 'services/Telemetry'
import Spinning from './Common/Spinner/Spinning'

export const OnlyAuthenticated = () => {
  const location = useLocation()
  const auth0 = useAuth0()

  useEffect(() => {
    if (auth0.isAuthenticated) {
      AuthService.Build(auth0)
    }
  }, [auth0, auth0.isAuthenticated])

  if (auth0.isLoading) {
    console.info('loading credentials')
    return <Spinning />
  }

  if (!auth0.isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{
          returnUrl: location.pathname + location.search + location.hash,
        }}
      />
    )
  }

  SegmentService.getInstance().page(location.pathname)

  return <Outlet />
}
